'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

var REQUEST_CHANNEL_PREFIX = 'event-source-request-id';
var GLOBAL_GRAPH_NAME = '1';
var PageKey = /*#__PURE__*/function (PageKey) {
  PageKey["SchemaDesigner"] = "/schema-designer";
  PageKey["LoadingBuilder"] = "/loading-builder";
  PageKey["GraphExplorer"] = "/graph-explorer";
  PageKey["QueryBuilder"] = "/query-builder";
  PageKey["QueryEditor"] = "/query-editor";
  PageKey["Actions"] = "/actions";
  PageKey["LoadingExecutor"] = "/loading-executor";
  return PageKey;
}({});

/** Represent GSQL role's privilege's key. */
var GSQLPrivilege = /*#__PURE__*/function (GSQLPrivilege) {
  GSQLPrivilege["ReadSchema"] = "READ_SCHEMA";
  GSQLPrivilege["WriteSchema"] = "WRITE_SCHEMA";
  GSQLPrivilege["ReadLoadingJob"] = "READ_LOADINGJOB";
  GSQLPrivilege["ExecuteLoadingJob"] = "EXECUTE_LOADINGJOB";
  GSQLPrivilege["WriteLoadingJob"] = "WRITE_LOADINGJOB";
  GSQLPrivilege["WriteDataSource"] = "WRITE_DATASOURCE";
  GSQLPrivilege["ReadRole"] = "READ_ROLE";
  GSQLPrivilege["WriteRole"] = "WRITE_ROLE";
  GSQLPrivilege["ReadUser"] = "READ_USER";
  GSQLPrivilege["WriteUser"] = "WRITE_USER";
  GSQLPrivilege["ReadProxyGroup"] = "READ_PROXYGROUP";
  GSQLPrivilege["WriteProxyGroup"] = "WRITE_PROXYGROUP";
  GSQLPrivilege["ReadFile"] = "READ_FILE";
  GSQLPrivilege["WriteFile"] = "WRITE_FILE";
  GSQLPrivilege["DropGraph"] = "DROP_GRAPH";
  GSQLPrivilege["ExportGraph"] = "EXPORT_GRAPH";
  GSQLPrivilege["ClearGraphStore"] = "CLEAR_GRAPHSTORE";
  GSQLPrivilege["DropAll"] = "DROP_ALL";
  GSQLPrivilege["AccessTag"] = "ACCESS_TAG";
  GSQLPrivilege["ReadData"] = "READ_DATA";
  GSQLPrivilege["CreateData"] = "CREATE_DATA";
  GSQLPrivilege["UpdateData"] = "UPDATE_DATA";
  GSQLPrivilege["DeleteData"] = "DELETE_DATA";
  GSQLPrivilege["AppAccessData"] = "APP_ACCESS_DATA";
  GSQLPrivilege["ReadQuery"] = "READ_QUERY";
  GSQLPrivilege["WriteQuery"] = "WRITE_QUERY";
  GSQLPrivilege["Owner"] = "OWNER";
  GSQLPrivilege["CreateQuery"] = "CREATE_QUERY";
  GSQLPrivilege["UpdateQuery"] = "UPDATE_QUERY";
  GSQLPrivilege["DropQuery"] = "DROP_QUERY";
  GSQLPrivilege["InstallQuery"] = "INSTALL_QUERY";
  GSQLPrivilege["ExecuteQuery"] = "EXECUTE_QUERY";
  return GSQLPrivilege;
}({});
var ACCESS_PRIVILEGES = _defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"]({}, PageKey.SchemaDesigner, [GSQLPrivilege.ReadSchema]), PageKey.LoadingBuilder, [GSQLPrivilege.ReadSchema, GSQLPrivilege.ReadLoadingJob]), PageKey.LoadingExecutor, [GSQLPrivilege.ReadSchema, GSQLPrivilege.ReadLoadingJob]), PageKey.GraphExplorer, [GSQLPrivilege.ReadSchema]), PageKey.QueryBuilder, [GSQLPrivilege.ReadSchema]), PageKey.QueryEditor, [GSQLPrivilege.ReadQuery]), PageKey.Actions, []);
var PAGE_NAME = _defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"]({}, PageKey.SchemaDesigner, 'Design Schema'), PageKey.LoadingBuilder, 'Map Data To Graph'), PageKey.GraphExplorer, 'Explore Graph'), PageKey.QueryEditor, 'Write Queries'), PageKey.Actions, 'Actions');
var PAGE_INDEX = _defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"](_defineProperty__default["default"]({}, PageKey.SchemaDesigner, 0), PageKey.LoadingBuilder, 1), PageKey.GraphExplorer, 2), PageKey.QueryEditor, 3), PageKey.Actions, 4);

exports.ACCESS_PRIVILEGES = ACCESS_PRIVILEGES;
exports.GLOBAL_GRAPH_NAME = GLOBAL_GRAPH_NAME;
exports.GSQLPrivilege = GSQLPrivilege;
exports.PAGE_INDEX = PAGE_INDEX;
exports.PAGE_NAME = PAGE_NAME;
exports.PageKey = PageKey;
exports.REQUEST_CHANNEL_PREFIX = REQUEST_CHANNEL_PREFIX;
